import { RootState } from "@/redux/store"
import { TypedUseSelectorHook, useSelector } from "react-redux"

export const useTypeSelector: TypedUseSelectorHook<RootState> = useSelector
